import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-37c23b34"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "info-order-list"
};
var _hoisted_2 = /*#__PURE__*/_createTextVNode(" 选手限");
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "hl"
  }, "1", -1);
});
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, [/*#__PURE__*/_createTextVNode(" 请务必使用"), /*#__PURE__*/_createElementVNode("span", {
    class: "hl"
  }, "最新版本（至少80.0以上）的Chrome"), /*#__PURE__*/_createTextVNode("浏览器访问； ")], -1);
});
var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, " 电脑建议操作系统：windows系统，win7及win7以上，8G以上内存，CPU建议酷睿i5以上，C盘（或系统盘）有4G以上剩余硬盘空间； ", -1);
});
var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, "正式答题之前请关闭QQ、微信等即时通信软件；", -1);
});
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, " 请在规定时间作答完全部题目，答题时间结束时，无论是否答完系统都将自动交卷； ", -1);
});
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("li", null, " 如果答题过程中因电源、网络故障等造成中断，请尽快再次登录，原有答题都会保存在系统中。 ", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("ol", _hoisted_1, [_createElementVNode("li", null, "活动包含" + _toDisplayString(_ctx.data.baseInfoText) + "；", 1), _createElementVNode("li", null, [_hoisted_2, _hoisted_3, _createTextVNode("次答题机会，" + _toDisplayString(_ctx.data.answerRule) + "超时自动提交； ", 1)]), _hoisted_4, _hoisted_5, _hoisted_6, _hoisted_7, _hoisted_8]);
}